import React from 'react';

import GoogleMapReact from 'google-map-react';

import * as propTypes from 'lib/prop_types';
import { ENV } from 'lib/react_on_rails/env';

import * as styles from './google_map.module.css';

function GoogleMap({
  center,
  className = styles.DefaultWrapper,
  withMarker = false,
}) {
  return (
    <div className={className}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: ENV?.GOOGLE_BROWSER_API_KEY }}
        defaultCenter={center}
        defaultZoom={12}
      >
        {withMarker && (
          // GoogleMapReact reads lat and lng props here to place the marker
          // oxlint-disable-next-line react/no-unknown-property
          <div className={styles.Marker} lat={center.lat} lng={center.lng} />
        )}
      </GoogleMapReact>
    </div>
  );
}

GoogleMap.propTypes = {
  center: propTypes.shape({
    lat: propTypes.number,
    lng: propTypes.number,
  }).isRequired,
  className: propTypes.string,
  withMarker: propTypes.bool,
};

export { GoogleMap };
